import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { SubmitButton } from "components/common/buttons/SubmitButton";

const MarkTranslationCompletedModal = ({ isOpen, onClose, onConfirm, loader }) => {
  const [completed, setCompleted] = useState(true);
  const [notes, setNotes] = useState("");

  useEffect(() => {
    if (isOpen) {
      setCompleted(true);
      setNotes("");
    }
  }, [isOpen]);

  const handleSubmit = (event) => {
    event.preventDefault();
    onConfirm({ completed: completed ? 1 : 0, notes });
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered className="modal-medium">
      <form onSubmit={handleSubmit}>
        <ModalHeader className="header_modal align-items-center">
          <h5 className="modal-title_u">Mark as Completed</h5>
        </ModalHeader>
        <ModalBody className="modal_form_body">
          
          <div className="row-primary mt-3">
            <h2>Notes</h2>
            <textarea
              className="input-in type_inp"
              value={notes}
              onChange={(event) => setNotes(event.target.value)}
              placeholder="Enter notes"
              rows={4}
            />
          </div>

          <label className="custom-checkbox checkbox d-flex align-items-center gap-2">
            <input
              type="checkbox"
              checked={completed}
              onChange={(event) => setCompleted(event.target.checked)}
            />
            <span className="checkmark"></span>
            <span style={{color: '#6C889C', fontSize: '15px', width: '100%', marginTop: '2px'}}>Attach the deliverables in the client email,</span>
          </label>
        </ModalBody>
        <ModalFooter>
          <SubmitButton btnText="Submit" loader={loader} disabled={loader} />
          <button className="table_delete" type="button" onClick={onClose} disabled={loader}>
            Cancel
          </button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default MarkTranslationCompletedModal;
